import { SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { getEkoCustomers } from "../EkoEndpoint";
import { Images } from "../../../../Controller";
import { setselectedTab } from "../../../../Store/B2bslice";
import ReciepientCard from "./ReciepientCard";

const GetCustomer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [mobile, setMobile] = useState("");
  const [loader, setLoader] = useState(false);
  const checkKyc = useSelector((state) => state.B2B.profileDetail);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const [customerDetails, setCustomerDetails] = useState({});

  const handleChange = (e) => {
    const { value } = e.target;
    const sanitized = value.replace(/[^0-9]/g, "");
    const limitedNumbers = sanitized.slice(0, 10);
    setMobile(limitedNumbers);
  };
  const handleSearch = () => {
    setLoader(true);
    const formdata = new FormData();
    formdata.append("mobile", mobile);
    getEkoCustomers(formdata)
      .then((res) => {
        if (res.status) {
          setCustomerDetails(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
        setCustomerDetails({});
      })
      .finally(() => setLoader(false));
  };
  const handleAdd = () => {
    // throw new Error("error occured")
    navigate("/eko/dmt/addCustomers");
  };
  useEffect(() => {
    dispatch(setselectedTab("300.12"));
    if (!memberServices.includes("104")) {
      navigate("/not-Available");
    } else {
      // getAllBanks();
    }
  }, []);


  return (
    <>
      <Spin spinning={loader}>
        <p className="font-bold text-xl font-sans">Customer Search</p>
        <div className="rounded-md mt-2 px-2 h-14  md:w-1/2 flex justify-between items-center  bg-inputbg ">
          <input
            onChange={handleChange}
            value={mobile}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                mobile && handleSearch();
              }
            }}
            placeholder="Search here..."
            className="outline-none border-none w-full px-4 text-sm bg-inputbg "
          />
          <SearchOutlined
            onClick={() => mobile && handleSearch()}
            className={`text-sm ${
              mobile ? "cursor-pointer" : "cursor-not-allowed"
            } bg-bsgray600 text-bswhite border border-bsgray500 rounded-full w-10 h-9 flex justify-center items-center`}
          />
        </div>
        {
          
        }
        <ReciepientCard
          handleSearch={handleSearch}
          mobile={mobile}
          customerDetails={customerDetails}
        />
        {Object.keys(customerDetails).length === 0 ? (
          <div className="flex flex-col justify-center mt-32 items-center">
            <img src={Images.nodata} alt="noCustomer" />
            <p className="font-semibold text-sm ">No Customer Found</p>
            <p
              onClick={handleAdd}
              className="bg-primary cursor-pointer hover:bg-primaryhover transition-all text-bswhite p-4 mt-2 rounded-3xl font-semibold"
            >
              + Add Customer
            </p>
          </div>
        ) : (
          <>
            <div className="bg-bswhite text-xs animate-fade-in font-semibold mt-2 grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 w-full place-items-start gap-2 border border-primary  p-4 rounded-md ">
              <div>
                <p>Name</p>
                <p>
                  {customerDetails?.first_name +
                    " " +
                    customerDetails?.last_name}
                </p>
              </div>
              <div>
                <p>Limit Available</p>
                <p className="text-green-500">
                  {customerDetails?.limit_available}
                </p>
              </div>
              <div>
                <p>Limit Consumed</p>
                <p className="text-red-500">
                  {customerDetails?.limit_consumed}
                </p>
              </div>
              <div>
                <p>Mobile</p>
                <p>{customerDetails?.remiiter_mobile}</p>
              </div>
              <div>
                <p>Address</p>
                <p>
                  {customerDetails?.address ? customerDetails?.address : "--"}
                </p>
              </div>
            </div>
            {/* <ReciepientCard
              handleSearch={handleSearch}
              mobile={mobile}
              customerDetails={customerDetails}
            /> */}
          </>
        )}
      </Spin>
    </>
  );
};

export default GetCustomer;
